import React from 'react';
import './TodosError.css';

export function TodosError() {
  return (
    <li className='TodosError'>
      <h4>Whoops!</h4>
      <span className='Emoji'>😕</span>
      Something went wrong while loading your To-Do list...
    </li>
  )
}